<template>
  <section id="contact" class="contact-section py-5">
    <div class="container">
      <div class="row g-4 align-items-center">
        <!-- Columna izquierda: título y botones -->
        <div class="col-12 col-lg-8">
          <div class="send-message p-4 p-lg-5">
            <h1 class="mb-3 text-center text-lg-start">Contáctame</h1>

            <div
              class="d-flex flex-column flex-sm-row flex-wrap gap-2 mt-3 justify-content-center justify-content-lg-start"
            >
              <a
                href="https://wa.me/50494565133"
                target="_blank"
                class="btn btn-success flex-fill flex-sm-grow-0"
              >
                Whatsapp <i class="fa-brands fa-whatsapp ms-2"></i>
              </a>

              <a
                href="https://github.com/andres15mol"
                target="_blank"
                class="btn btn-dark flex-fill flex-sm-grow-0 iconos-apps"
              >
                Github <i class="fa-brands fa-github ms-2"></i>
              </a>

              <a
                href="https://www.linkedin.com/in/andrés-alejandro-molina-039276230"
                target="_blank"
                class="btn btn-primary flex-fill flex-sm-grow-0 iconos-apps"
              >
                LinkedIn <i class="fa-brands fa-linkedin ms-2"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Columna derecha: info de contacto -->
        <div class="col-12 col-lg-4">
          <div
            class="contact-info h-100 d-flex flex-column align-items-center justify-content-center p-4"
          >
            <h3 class="text-center mb-2 text-dark">INFO</h3>
            <div class="info d-flex flex-column text-center align-items-center">
              <a href="tel:+50494565133" class="contact-link mb-1">
                (+504) 9456-5133
              </a>
              <a href="mailto:andres15mol@hotmail.com" class="contact-link">
                andres15mol@hotmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.contact-section {
  /* Para que respire un poco en pantallas pequeñas */
  min-height: 60vh;
}

/* Tarjeta izquierda */
.send-message {
  background-color: #ffffff;
  border-radius: 0.75rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
}

/* Tarjeta derecha */
.contact-info {
  background-color: #f8f9fa;
  border-radius: 0.75rem;
}

.contact-link {
  text-decoration: none;
  color: #212529;
  font-weight: 500;
}

.contact-link:hover {
  text-decoration: underline;
}

/* Ajustes tipográficos en pantallas pequeñas */
@media (max-width: 575.98px) {
  h1 {
    font-size: 1.7rem;
  }

  h3 {
    font-size: 1.1rem;
  }
}

/* En pantallas grandes alineamos a la izquierda el título y botones */
@media (min-width: 992px) {
  .send-message h1 {
    text-align: left;
  }
}
</style>
